import React from 'react';
import { EtapaContaServicoProps } from './types';
import { formatarPerfil } from './utils';

const EtapaContaServico: React.FC<EtapaContaServicoProps> = ({
  unidades,
  contas,
  contasSelecionadas,
  permissoesPorConta,
  onToggleConta,
  slideDirection
}) => {
  const selecionadosIds = new Set(contasSelecionadas.map(c => c.clientId));

  const tooltip = 'Contas de serviço são credenciais que permitem que sistemas externos (como portais de inscrição) se comuniquem com este processo de forma segura e automatizada. Cada conta tem um conjunto de permissões que define o que ela pode fazer.';

  return (
    <div style={{
      animation: slideDirection === 'right' ? 'slideInRight 0.3s ease-out' : 'slideInLeft 0.3s ease-out'
    }}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <label className="form-label fw-semibold mb-0" style={{ fontSize: '14px', color: '#495057' }}>
          Contas de Serviço
        </label>
        <i
          className="bi bi-info-circle"
          title={tooltip}
          style={{ fontSize: '14px', color: '#6c757d', cursor: 'help' }}
        ></i>
      </div>

      {contas.length === 0 ? (
        <div className="alert alert-warning" style={{ borderRadius: '8px', fontSize: '13px' }}>
          <i className="bi bi-exclamation-triangle me-2"></i>
          Nenhuma conta de serviço disponível. Clique em "Criar Processo" para continuar sem integração.
        </div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {contas.map(conta => {
            const selecionada = selecionadosIds.has(conta.clientId);
            const nomeUnidade = unidades.find(u => u.id === conta.unidadeId)?.nome;
            const permissoes = permissoesPorConta[conta.clientId];
            return (
              <div
                key={conta.clientId}
                className="edital-card"
                style={{
                  cursor: 'pointer',
                  borderColor: selecionada ? '#0d6efd' : '#e9ecef',
                  background: selecionada ? '#f0f7ff' : '#f8f9fa'
                }}
                onClick={() => onToggleConta(conta)}
              >
                <div className="d-flex align-items-start gap-3">
                  <input
                    type="checkbox"
                    className="form-check-input modern-checkbox mt-1"
                    checked={selecionada}
                    onChange={() => onToggleConta(conta)}
                    onClick={e => e.stopPropagation()}
                  />
                  <div className="flex-grow-1">
                    <div className="fw-semibold" style={{ fontSize: '14px' }}>
                      {formatarPerfil(conta.perfilNome)}{nomeUnidade ? ` — ${nomeUnidade}` : ''}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6c757d' }}>{conta.descricao}</div>
                    {selecionada && permissoes && (
                      <div className="mt-2" style={{ fontSize: '12px' }}>
                        {[...(permissoes.permissoesPerfil || []), ...(permissoes.permissoesCustomizadas || [])].map((p: any) => (
                          <span key={p.id} className="badge me-1 mb-1" style={{ background: '#e9ecef', color: '#495057', fontWeight: 400 }}>
                            {p.descricao}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EtapaContaServico;
